<template>
    <div>
        <v-card class="mt-6 pa-3" color="#eee">
            <v-row>
                <v-col cols="12" sm="12">
                    <v-row>
                        <v-btn @click="$emit('deleted', tid)" class="ml-6 mt-3" color="error">刪除</v-btn>
                        <span class="mt-6 ml-3">{{q_index}}.</span>
                        <v-text-field v-model="title" @change="update" single-line="" class="input_400 ml-3" label="請輸入問題"></v-text-field>
                    </v-row>
                    <v-row v-for="(o, idx) in choice" :key="idx" class='ml-12 pl-12'>
                        <v-radio-group><v-radio label="" value="" :disabled="true"></v-radio></v-radio-group>
                        <v-text-field v-model="o.title" @change="update" single-line class="input_400" label="新增選項"></v-text-field>
                        <v-text-field v-model="o.score" @change="update" single-line="" class="input_100 ml-3" outlined label="分數"></v-text-field>
                        <v-btn @click="edit_idx=idx; msg=o.trigger_msg; push_dialog=true" class="ml-3 mt-3" :color="o.trigger_msg==''?'primary':'success'">觸發訊息</v-btn>
                        <v-btn @click="single_delete(o.id); update()" class="ml-3 mt-3" text icon color="error">
                            <v-icon>mdi-delete</v-icon>
                        </v-btn>
                    </v-row>
                    <v-row class='pl-12'>
                        <v-btn @click="add_option" text color="blue" class='ml-12'>
                            <v-icon>mdi-plus</v-icon>新增選項
                        </v-btn>
                    </v-row>
                </v-col>
            </v-row>
        </v-card>

        <v-dialog v-model="push_dialog" max-width="600px" persistent>
            <v-card style="overflow: hidden;">
                <v-card-title class="headline grey lighten-2">傳送訊息
                    <v-spacer/>
                    <v-icon @click="push_dialog=false">mdi-close</v-icon>
                </v-card-title>
                <v-card-text class="mt-4 pa-6">
                    <v-row>
                        <v-textarea outlined v-model="msg" label="輸入您要傳送的訊息"></v-textarea>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pl-6 pr-6" justify="center">
                    <v-row justify="center">
                        <v-btn color="success" @click="choice[edit_idx].trigger_msg=msg; push_dialog = false; update()" block>送出</v-btn>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>

</template>


<script>
export default {
    props: {
        tid: {
            type: Number,
            default: -1,
        },
        index: {
            type: Number,
            default: -1,
        },
        question: {
            type: Object,
            default: function () {return {title: "", choice: [], trigger_msg: ''}}
        }
    },
    data(){
        return{
            q_index: -1,
            title: "",
            choice: [],
            push_dialog: false,
            msg: '',
            edit_idx: -1,
        }
    },
    watch:{
        index: function(val){
            this.q_index = val
        },
        question: function(val){
            this.title = val.title
            this.choice = val.choice
        }
    },
    mounted(){
        console.log(this.question)
        this.q_index = this.index
        this.title = this.question.title
        this.choice = this.question.choice
        console.log(this.choice)
    },
    methods:{
        single_delete(id){
            this.choice.splice(this.choice.findIndex(e=>e.id==id), 1)
        },
        add_option(){
            this.choice.push({
                id: (this.choice.length+1)*-1,
                title: '',
                score: '',
                trigger_msg: '',
            })
        },
        update(){
            this.$emit('update', [this.tid, {title: this.title, choice: this.choice}])
        },
    },
}
</script>
